/*eslint-disable @typescript-eslint/no-unsafe-member-access*/
/*eslint-disable @typescript-eslint/no-floating-promises*/
import { useEffect } from 'react';

import { Alert } from 'src/common/components/Alert';

import { fetchCampaigns, fetchPhones } from '../api';

import { PhoneFilter } from './components/PhoneFilter';
import { PhoneList } from './components/PhoneList';
import { PhoneListContext } from './context';
import { useActions } from './useActions';

export const Phones = (): JSX.Element => {
  const { state, dispatch, ...actions } = useActions();
  const { setPhones, setLoadingPhones, setCampaigns } = actions;
  const { phones, search, currentPage, assigningToCampaign, error, assigningToAccount } = state;

  useEffect(() => {
    setLoadingPhones(true);
    fetchPhones(search, currentPage)
      .then((result) => {
        setPhones(result.data.results, result.data.count);
      })
      .catch(() => {
        setPhones([], 0, 'An error occurred while loading phone numbers.');
      })
      .finally(() => {
        setLoadingPhones(false);
      });
  }, [dispatch, setPhones, setLoadingPhones, search, currentPage]);

  useEffect(() => {
    fetchCampaigns().then((result) => {
      setCampaigns(result);
    });
  }, [setCampaigns]);

  return (
    <PhoneListContext.Provider value={{ state, dispatch, actions }}>
      <div className="flex flex-col p-8" style={{ height: 'calc(100vh - 66px)' }}>
        <h2 className="sm:px-0 px-4 pb-4">Phones</h2>
        {assigningToCampaign && (
          <Alert className="mb-6" loading>
            Please wait until phone is assigned to campaign
          </Alert>
        )}
        {assigningToAccount && (
          <Alert className="mb-6" loading>
            Please wait until phone is assigned to account
          </Alert>
        )}
        <PhoneFilter />
        {!!error && (
          <Alert className="mb-6" type="error">
            {error}
          </Alert>
        )}
        {!error && <PhoneList phones={phones} />}
      </div>
    </PhoneListContext.Provider>
  );
};
